export const YearText = {
  current: 'April 2024',
  previous: 'April 2023',
};

/*
export const UtbildningData = [
  {
    category: 'Hälso- och sjukvård, social omsorg',
    currentYear: 2.3,
    previousYear: 2.3,
  },
  { category: 'Övrig utbildning', 
    currentYear: 2.6, 
    previousYear: 2.5 },
  {
    category: 'Pedagogik & lärarutbildning',
    currentYear: 2.8,
    previousYear: 2.7,
  },
  { category: 'Teknik & tillverkning', 
    currentYear: 3.6, 
    previousYear: 3.0 },
  {
    category: 'Lant- och skogsbruk, djursjukvård',
    currentYear: 4.2,
    previousYear: 4.4,
  },
  {
    category: 'Samhällsvetenskap, juridik, handel & administration',
    currentYear: 5.2,
    previousYear: 4.7,
  },
  {
    category: 'Naturvetenskap, matematik & data',
    currentYear: 6.7,
    previousYear: 5.8,
  },
  { category: 'Humaniora & konst', 
    currentYear: 8.4, 
    previousYear: 7.4 },
];

export const KonData = [
  {
    category: 'Man',
    currentYear: 4.3,
    previousYear: 3.9,
  },
  {
    category: 'Kvinna',
    currentYear: 4.0,
    previousYear: 3.6,
  },
];

export const AlderData = [
  {
    category: 'Åldersgrupp - 29 år',
    currentYear: 3.6,
    previousYear: 3.2,
  },
  {
    category: '30 - 39 år',
    currentYear: 4.3,
    previousYear: 3.8,
  },
  {
    category: '40 - 49 år',
    currentYear: 3.7,
    previousYear: 3.4,
  },
  {
    category: '50 – 59 år',
    currentYear: 4.3,
    previousYear: 3.8,
  },
  {
    category: '60 – 64 år',
    currentYear: 5.7,
    previousYear: 5.2,
  },
];

export const UtlandData = [
  { category: 'Inrikes födda', currentYear: 2.3, previousYear: 1.9 },
  { category: 'Norden exkl sverige', currentYear: 2.9, previousYear: 2.7 },
  { category: 'Utanför norden', currentYear: 10.5, previousYear: 10.1 },
];

*/